/**
 * Track invalid fields in HEAP
 * @param {String} invalidFieldName - invalid field name
 **/
export function trackInvalidFieldsInHeap(invalidFieldName) {
	window.modUtils.heap('track', ['Validation Error | ' + invalidFieldName, {}]);
}
